import {
  IContentAreaProps,
  IDataContext, IIndicator,
  IMenuButton,
  IViewController
} from "../../types";
import { ReactElement } from "react";
import ViewCompact from "@mui/icons-material/ViewCompact";
import DashboardIcon from "@mui/icons-material/Dashboard";

import ProductionReportRM from "./production/productionReportRM";

class Module implements IViewController {

  private managementButton: IMenuButton = {
    title: "Production",
    icon: <ViewCompact/>,
    color: "green",
    dataContext: {
      title: "Production",
      module: "mill",
      subModule: "production/wireRod"
    }
  };

  private dashboardButton: IMenuButton = {
    title: "Dashboard",
    icon: <DashboardIcon/>,
    color: "cyan",
    disabled: true,
    dataContext: {
      title: "Dashboard",
      module: "mill",
      subModule: "production/dashboard"
    }
  };


  private buttons = [this.managementButton, this.dashboardButton];

  public getModuleName(): string{
    return "mill";
  }

  public getView(dataContext: IDataContext, props: IContentAreaProps): ReactElement {

    if (dataContext.subModule === "production/wireRod") {
      return <ProductionReportRM parentSize={props.parentSize} />;
    }

    return <div />;
  }

  getButtons(): IMenuButton[] {
    return [];
  }

  getButton(subModule: string): IMenuButton | undefined {
    return this.buttons.find(x => x.dataContext && x.dataContext.subModule === subModule);
  }

  getIndicator(dataContext: IIndicator): ReactElement | undefined {
    if (dataContext.component === "") {
      return <div />;
    }

    return undefined;
  }
}

const instance = new Module();

export default instance;
